
export default {
	props: {
		definitionType: {
			required: true,
			type: String,
		},
		definition: {
			required: true,
			type: String,
		},
		word: {
			required: true,
			type: String,
		},
		isLoading: {
			required: false,
			type: Boolean,
			default: () => false,
		},
	},
	computed: {
		yourDictionaryLink() {
			return `//www.yourdictionary.com/${this.word}`;
		},
	},
};
